import { TextField } from '@mui/material';

type StreetAdditionalInputProps = {
  value: string;
  onChange: (value: string) => void;
};

export function StreetAdditionalInput({
  value,
  onChange,
}: StreetAdditionalInputProps) {
  return (
    <TextField
      type='text'
      label='Adresszusatz'
      id='street-additional'
      size='small'
      value={value}
      onChange={event => onChange(event.target.value)}
      fullWidth
    />
  );
}
